import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Crown, Facebook, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PB_LOGO = "/brand/pb-logo.png";

export const GoldCertificate = ({ cert, compact = false }) => (
  <div className={`border-2 border-yellow-500/80 bg-black shadow-[0_0_34px_rgba(212,175,55,0.35)] p-1 ${compact ? "" : "max-w-xl mx-auto"}`}
    data-testid="gold-certificate">
    <div className="border border-yellow-500/40 px-6 py-8 text-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: `url(${PB_LOGO})`, backgroundSize: "160px", backgroundPosition: "center", backgroundRepeat: "no-repeat" }} />
      <Crown className="w-9 h-9 text-yellow-400 mx-auto mb-2" style={{ filter: "drop-shadow(0 0 12px rgba(212,175,55,.8))" }} />
      <div className="text-[9px] font-black uppercase tracking-[0.45em] text-yellow-400">Pickle Bullpen · Performance OS</div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-4">certifies that</div>
      <div className="font-display font-black uppercase text-2xl sm:text-3xl text-white mt-1" data-testid="certificate-name">{cert.name}</div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-3">has completed the full</div>
      <div className="font-display font-black uppercase text-lg text-yellow-400 mt-0.5">Tournament Director Training</div>
      <div className="text-[11px] text-zinc-400 mt-2 max-w-sm mx-auto">
        Event creation · rosters · draws · courts · scoring · medal matches · champions — start to finish, under official tournament law.
      </div>
      <div className="flex items-center justify-center gap-6 mt-5 text-[9px] uppercase tracking-widest text-zinc-500">
        <span className="flex items-center gap-1"><ShieldCheck className="w-3.5 h-3.5 text-yellow-500" /> {cert.cert_no}</span>
        <span>{cert.issued_at ? new Date(cert.issued_at).toLocaleDateString() : ""}</span>
      </div>
    </div>
  </div>
);

export default function Certificate() {
  const { cid } = useParams();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/certificates/${cid}`).then((r) => {
      setCert(r.data);
      document.title = `${r.data.name} — Certified TD · Pickle Bullpen`;
    }).catch(() => setError("Certificate not found."));
  }, [cid]);
  if (error) return <div className="min-h-screen bg-[#0a0a0a] text-zinc-500 flex items-center justify-center font-display uppercase">{error}</div>;
  if (!cert) return <div className="min-h-screen bg-[#0a0a0a] text-zinc-600 flex items-center justify-center animate-pulse">Loading certificate…</div>;
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center px-4 py-10" data-testid="certificate-page">
      <GoldCertificate cert={cert} />
      <div className="flex gap-3 mt-6">
        <a data-testid="certificate-share-btn"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${process.env.REACT_APP_BACKEND_URL}/api/share/certificate/${cid}`)}`}
          target="_blank" rel="noopener noreferrer"
          className="flex items-center gap-2 border border-[#1877F2]/70 text-[#7db4f5] text-[10px] font-black uppercase tracking-widest px-4 py-2.5 hover:bg-[#1877F2]/20 transition-colors">
          <Facebook className="w-4 h-4" /> Share on Facebook
        </a>
        <a href="/" className="border border-zinc-700 text-zinc-400 text-[10px] font-black uppercase tracking-widest px-4 py-2.5 hover:border-yellow-500 hover:text-yellow-400 transition-colors">
          Pickle Bullpen
        </a>
      </div>
    </div>
  );
}
